import { Constants } from '@leverege/api-redux';
import { ItemDelegate } from '@leverege/molten-core';
import Groupings from "../../groupings/Groupings.js";
import FilterSourcesModel from "../../filters/FilterSourcesModel.js";
import RequestUtil from "./RequestUtil.js";
/**
 * The ImagineAggRequestor will request aggregations throught Imagine's
 * interface search mechanism. The context requires the GroupAction needed
 * to determine the aggregations, and the the filters object
 */
const ImagineAggRequestor = {
  createPlugin: () => {
    return {
      id: 'imagine.blueprint.AggRequestor',
      type: 'imagine.blueprint.AggRequestor',
      requestor: ImagineAggRequestor
    };
  },
  requestAggs: async (grpObjRef, grouping, context, {
    dispatch,
    getState,
    opts
  }) => {
    if (grpObjRef == null || grouping == null || opts == null) {
      return null;
    }
    // const { api } = opts
    let {
      filters,
      delegate
    } = context;
    if (delegate instanceof ItemDelegate) {
      delegate = delegate.parent();
    }
    filters = filters || {};
    const objectType = delegate.relationship.objectType;
    const aggs = RequestUtil.getAggOptions(grouping, objectType);
    if (aggs) {
      const fm = FilterSourcesModel.removeSource(filters, RequestUtil.FILTER_NAME);
      const filter = FilterSourcesModel.getFilter(fm);
      const queryName = `molten.grouping:${grpObjRef.id}`;
      const results = await dispatch(delegate.search({
        filter,
        aggs,
        limit: 0,
        ttl: 30000,
        queryName
      }));
      const aggregations = RequestUtil.processAggResults(grouping, objectType, results);
      return aggregations;
    }
    return null;
  },
  installUpdater: (grpObjRef, grouping, context, callback) => {
    const {
      relationship,
      match
    } = context;
    const r = relationship.match ? relationship : relationship.createResolved(match);
    const path = r.ref;
    const startsWith = RequestUtil.findRelationshipPaths(grouping, `${grpObjRef.ref}/${grpObjRef.id}`);

    // We are going to trigger an update on any change to the current list or any
    // change under a relationship value source
    const cb = action => {
      if (action.parentPath === path || action.path === path) {
        callback();
      } else if (startsWith == null) {} else if (startsWith.length === 1) {
        if (action.parentPath?.startsWith(startsWith[0]) || action.path?.startsWith(startsWith[0])) {
          callback();
        }
      } else {
        for (let n = 0; startsWith.length; n++) {
          if (action.parentPath?.startsWith(startsWith[n]) || action.path?.startsWith(startsWith[n])) {
            callback();
          }
        }
      }
    };
    return Groupings.addUpdateListener([Constants.INTERFACE_UPDATE, Constants.INTERFACE_CREATE_ADD, Constants.INTERFACE_CREATE_SET, Constants.INTERFACE_REMOVE], cb);
  }
};
export default ImagineAggRequestor;